import { DEAL_WON_STATUSES } from '../../constants';
import type { Deal } from '../../types/domain';
import { dealActualRevenueForYear } from './actualRevenue';
import { dealYearsOf } from './dealYear';
import { dealSoldRevenue } from './soldRevenue';

// C.A cumulé d'un contact : somme du C.A vendu de ses affaires gagnées (devis accepté / en cours / terminé).
export function contactTotalRevenue(clientId: string, deals: Deal[] | null | undefined): number {
  return (deals || [])
    .filter((a) => a.client_id === clientId && DEAL_WON_STATUSES.includes(a.statut as string))
    .reduce((s, a) => s + dealSoldRevenue(a, 'all'), 0);
}

// Répartition du C.A cumulé d'un contact par année civile, années triées de la plus récente
// à la plus ancienne, années sans C.A omises.
export function contactRevenueByYear(
  clientId: string,
  deals: Deal[] | null | undefined,
): { year: number; total: number }[] {
  const affs = (deals || []).filter(
    (a) => a.client_id === clientId && DEAL_WON_STATUSES.includes(a.statut as string),
  );
  const years = new Set(affs.flatMap(dealYearsOf).map(Number));
  return [...years]
    .sort((x, y) => y - x)
    .map((year) => ({
      year,
      total: affs.reduce((s, a) => s + dealActualRevenueForYear(a, year), 0),
    }))
    .filter((x) => x.total > 0);
}
